import { LabeledValue } from '@/lib/api';

export const EMAIL_LABELS = ['Work', 'Personal', 'Home', 'Other'];
export const PHONE_LABELS = ['Mobile', 'Work', 'Home', 'Other'];

export interface ContactBookSettings {
  defaultView: 'category' | 'date';
  sortBy: 'name' | 'gatheredAt' | 'company' | 'createdAt';
  sortDir: 'asc' | 'desc';
  selectedCategoryId: string | null;
}

export const DEFAULT_SETTINGS: ContactBookSettings = {
  defaultView: 'category',
  sortBy: 'gatheredAt',
  sortDir: 'desc',
  selectedCategoryId: null,
};

export const PRESET_COLORS = [
  '#6366f1',
  '#8b5cf6',
  '#ec4899',
  '#ef4444',
  '#f97316',
  '#eab308',
  '#22c55e',
  '#14b8a6',
  '#06b6d4',
  '#3b82f6',
  '#6b7280',
  '#78716c',
];

export type HistoryEntry = { id: string; text: string; date: string; showDate?: boolean };

export interface FormSnapshot {
  firstName: string;
  lastName: string;
  emails: LabeledValue[];
  phones: LabeledValue[];
  company: string;
  title: string;
  notes: string;
  source: string;
  categoryId: string;
  priorityId: string;
  gatheredAt: string;
  tags: string[];
  historyEntries: HistoryEntry[];
}
